import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DropdownItem } from '@widgets/dropdown/dropdown-type';
import {
  Alert,
  AlertConfiguration,
  AlertGroup,
  AlertRecipientGroup,
  BusinessPartner,
  MutedStation,
  Paging,
  PartnerLocation,
  SelectedAlert,
} from '../data/alerting.models';

export interface AlertingState {
  partnerList: BusinessPartner[];
  selectedPartner: DropdownItem<BusinessPartner>;
  locations: PartnerLocation[];
  selectedLocation: DropdownItem<PartnerLocation>;
  alerts: Alert[];
  loadingAlertDetailsFor: number | null;
  selectedAlert: SelectedAlert | null;
  loadingAlerts: boolean;
  noStationsFound: boolean;
  paging: Paging;
  groups: AlertGroup[];
  loadingGroups: boolean;
  selectedGroup: AlertGroup;
  loadingConfigurations: boolean;
  configurations: AlertConfiguration[];
  recipientGroups: AlertRecipientGroup[];
  loadingRecipientGroups: boolean;
  selectedRecipientGroup: AlertRecipientGroup;
  excelDownloadInProgress: boolean;
  mutedStations: MutedStation[];
  loadingMutedStations: boolean;
  mutedStationsPaging: Paging;
}

export const selectAlertingState = createFeatureSelector<AlertingState>('alerting');
export const partnerList = createSelector(selectAlertingState, state => state.partnerList);
export const selectedPartner = createSelector(selectAlertingState, state => state.selectedPartner);
export const locations = createSelector(selectAlertingState, state => state.locations || []);
export const selectedLocation = createSelector(
  selectAlertingState,
  state => state.selectedLocation
);
export const alerts = createSelector(selectAlertingState, state => state.alerts);
export const loadingAlertDetailsFor = createSelector(
  selectAlertingState,
  state => state.loadingAlertDetailsFor
);
export const selectedAlert = createSelector(selectAlertingState, state => state.selectedAlert);
export const loadingAlerts = createSelector(selectAlertingState, state => state.loadingAlerts);
export const excelDownloadInProgress = createSelector(
  selectAlertingState,
  state => state.excelDownloadInProgress
);
export const noStationsFound = createSelector(selectAlertingState, state => state.noStationsFound);
export const paging = createSelector(selectAlertingState, state => state.paging);
export const groups = createSelector(selectAlertingState, state => state.groups);
export const loadingGroups = createSelector(selectAlertingState, state => state.loadingGroups);
export const selectedGroup = createSelector(selectAlertingState, state => state.selectedGroup);
export const loadingConfigurations = createSelector(
  selectAlertingState,
  state => state.loadingConfigurations
);
export const configurations = createSelector(selectAlertingState, state => state.configurations);
export const recipientGroups = createSelector(selectAlertingState, state => state.recipientGroups);
export const loadingRecipientGroups = createSelector(
  selectAlertingState,
  state => state.loadingRecipientGroups
);
export const selectedRecipientGroup = createSelector(
  selectAlertingState,
  state => state.selectedRecipientGroup
);
export const mutedStations = createSelector(selectAlertingState, state => state.mutedStations);
export const loadingMutedStations = createSelector(
  selectAlertingState,
  state => state.loadingMutedStations
);
export const mutedStationsPaging = createSelector(
  selectAlertingState,
  state => state.mutedStationsPaging
);
